import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'please_describe_5'

export const dataPointDefinition = {
  retracedId: 'please_describe_5',
  name: 'Please describe:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'wb-22--2-5f',
      number: 'WB-WAGE-143.5',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'follow-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[3],wb-22--2-5x',
      machineShowHide: '[3],wb-22--2-5x',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-22--2-5f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35320,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
